import {
  PaperBlock,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import React from 'react'
import { ChoiceAnswer } from './ChoiceAnswer'
import { ShortAnswer } from './ShortAnswer'
import { FillInBlankAnswer } from './FillInBlankAnswer'

export const RenderAnswer: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
}> = ({ mainQuestion, block }) => {
  const { type } = mainQuestion
  switch (type) {
    case QuestionTypeEnum.SingleChoice:
    case QuestionTypeEnum.MultipleChoice: {
      return (
        <ChoiceAnswer
          mainQuestion={mainQuestion}
          block={block}
        />
      )
    }
    case QuestionTypeEnum.ShortAnswer: {
      return (
        <ShortAnswer
          mainQuestion={mainQuestion}
          block={block}
        />
      )
    }
    case QuestionTypeEnum.FillInBlank: {
      return (
        <FillInBlankAnswer
          mainQuestion={mainQuestion}
          block={block}
        />
      )
    }
    case QuestionTypeEnum.Product: {
      return <></>
    }
    default: {
      return <>未知题型</>
    }
  }
}
